import { render, staticRenderFns } from "./seguradoraPlanos.vue?vue&type=template&id=d6b5a2d6&"
import script from "./seguradoraPlanos.vue?vue&type=script&lang=js&"
export * from "./seguradoraPlanos.vue?vue&type=script&lang=js&"
import style0 from "./seguradoraPlanos.vue?vue&type=style&index=0&id=d6b5a2d6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports